import { useState, useEffect } from "react";
import axios from "axios";

export type Disponibilidade = {
  id: number;
  data: string;        // "2025-09-03"
  horaInicio: string;  // "08:00"
  horaFim: string;     // "12:00"
  ativo: boolean;
};

export const useDisponibilidades = (driverId: number) => {
  const [disponibilidades, setDisponibilidades] = useState<Disponibilidade[]>([]);
  const token = localStorage.getItem("token");
  const BASE_URL = process.env.REACT_APP_API_URL;

  const load = () => {
    if (!driverId) return;
    axios
      .get<Disponibilidade[]>(`${BASE_URL}/empresa/motoristas/disponibilidade/${driverId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setDisponibilidades(res.data))
      .catch(console.error);
  };

  const create = (data: string, horaInicio: string, horaFim: string, veiculoId: number) => {
  return axios
    .post(`${BASE_URL}/empresa/motoristas/disponibilidade/${driverId}`,
      { data, horaInicio, horaFim, veiculoId },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then(() => load());
};


  const remove = (id: number) => {
    return axios
      .delete(`${BASE_URL}/empresa/motoristas/disponibilidade/${driverId}/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => load());
  };

  useEffect(() => {
    load();
  }, [driverId]);

  return { disponibilidades, load, create, remove };
};
